import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { IMultiDropdownData } from 'src/app/shared/components/multi-dropdown/multi-dropdown.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-create-reservation-interval',
  templateUrl: './create-reservation-interval.component.html',
  styleUrls: ['./create-reservation-interval.component.scss']
})
export class CreateReservationIntervalComponent implements OnInit {

  /**
   * Date to start calculation from (last defined date)
   *
   * @type {Date}
   * @memberof CreateReservationIntervalComponent
   */
  @Input() startDate: Date;

  /**
   * Event raised on click on "Go!"
   *
   * @memberof CreateReservationIntervalComponent
   */
  @Output() datesGenerated = new EventEmitter<Date[]>();

  @Input() hideLabels: boolean;

  /**
   * Form instance
   *
   * @type {FormGroup}
   * @memberof CreateReservationIntervalComponent
   */
  formGroup: FormGroup;

  /**
   * number of items dropdown values
   *
   * @type {IMultiDropdownData[]}
   * @memberof CreateReservationIntervalComponent
   */
  selectNumberItemsValues: IMultiDropdownData[] = [];

  /**
   * interval dropdown values
   *
   * @type {IMultiDropdownData[]}
   * @memberof CreateReservationIntervalComponent
   */
  selectIntervalValues: IMultiDropdownData[] = [];

  constructor(private fb: FormBuilder, private translate: TranslateService) {
    this.createForm();
    this.initSelectIntervalValues();
    this.initSelectNumberItemsValues();
  }

  ngOnInit() {
  }

  /**
   * Handle click on "Go"
   *
   * @memberof CreateReservationIntervalComponent
   */
  onGoClick() {
    let interval: number;
    switch (this.selectedInterval) {
      case Interval.DAY:
        interval = 1;
        break;
      case Interval.WEEK:
        interval = 7;
        break;
      case Interval.TWO_WEEK:
        interval = 14;
        break;
    }

    const out: Date[] = [];
    for (let i = 0; i < this.selectedNumberItems; i++) {
      out[i] = new Date(this.startDate);
      out[i].setDate(out[i].getDate() + interval * (i + 1));
    }

    this.datesGenerated.emit(out);
  }

  private get selectedInterval(): number {
    return Number(this.formGroup.get('interval').value);
  }

  private get selectedNumberItems(): number {
    return Number(this.formGroup.get('numberItems').value);
  }

  /**
   * Create the form
   *
   * @private
   * @memberof CreateReservationIntervalComponent
   */
  private createForm() {
    this.formGroup = this.fb.group({
      numberItems: new FormControl('1', [
        Validators.required
      ]),
      interval: new FormControl(Interval.WEEK, [
        Validators.required
      ]),
    });
  }

  /**
   * Init number of items dropdown
   *
   * @private
   * @memberof CreateReservationIntervalComponent
   */
  private initSelectNumberItemsValues() {
    for (let i = 1; i <= 50; i++) {
      this.selectNumberItemsValues.push({ key: String(i), text: String(i), selected: null });
    }
  }

  /**
   * Init interval dropdown
   *
   * @private
   * @memberof CreateReservationIntervalComponent
   */
  private initSelectIntervalValues() {
    const values = [
      Interval.DAY,
      Interval.WEEK,
      Interval.TWO_WEEK
    ];

    values.forEach(x => { this.selectIntervalValues[x] = { key: String(x), text: String(x), selected: null }; });

    this.translate.get('INTERVAL_DAY').subscribe((text: string) => {
      this.selectIntervalValues[Interval.DAY].text = text;
    });

    this.translate.get('INTERVAL_WEEK').subscribe((text: string) => {
      this.selectIntervalValues[Interval.WEEK].text = text;
    });

    this.translate.get('INTERVAL_TWO_WEEK').subscribe((text: string) => {
      this.selectIntervalValues[Interval.TWO_WEEK].text = text;
    });
  }

}

enum Interval {
  DAY,
  WEEK,
  TWO_WEEK
}
